var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPluscircleDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 17,
    fill: "#ABB5BE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9979 16.0487H24V17.9797H17.9979V24H16.0021V17.9797H10V16.0487H16.0021V10H17.9979V16.0487Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPluscircleDisabled);
export default __webpack_public_path__ + "static/media/pluscircleDisabled.86ee83946cb0ea6e79996625eb187ea8.svg";
export { ForwardRef as ReactComponent };